export const cateringGoogleFormsLink = "https://forms.gle/2csc3vnqtUPLDvVd9"

export const googleMapsLink = "https://goo.gl/maps/LhRRcQfGv6dRFWXV7"

export const ezCaterLink =
  "https://www.ezcater.com/catering/pvt/damoori-kitchen-3"

export const tockBoxedLunchesLink =
  "https://www.exploretock.com/damoorikitchen/experience/318297/menu/boxed-lunch-catering"